export * from "/vercel/path0/node_modules/.pnpm/@vita-learning+styles@2.0.1/node_modules/@vita-learning/styles/dist/index.js"